// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__236-N","options":"AnswerScale_options__1hsiO","selected":"AnswerScale_selected__1k8WX"};